import React from 'react';

import cx from 'classnames';

import convertMjmlStyleProps from './convertMjmlStyleProps';

import styles from './styles.scss';

export default function MjmlWrapper({
  className,
  style,
  children,
  ...otherProps
}: any) {
  const dataTestId = otherProps['data-test'];

  return (
    <div
      data-test={dataTestId}
      className={cx(styles.MjmlWrapper, className)}
      style={{ ...style, ...convertMjmlStyleProps(otherProps) }}
    >
      {children}
    </div>
  );
}
